module.exports = __webpack_public_path__ + "img/gallery-image-20.7239b251.jpg";